// 포캐스팅 통계(/forecastmonthstat) - "중요도별 통계" → "포캐스팅 통계" 전환(2026-10-23).
// 본부/팀별 등록(REG)/수주(WON)/진행(PROGRESS)/실패(FAIL) 4개 상태의 건수·금액을 보여준다.
// 금액은 매출액 합계 - 백엔드 ForecastMonthDto.ForecastStatusDto(count/amount)와 짝.
export const cellTyps = [
  { id: 'count', name: '건수' },
  { id: 'amount', name: '금액' },
];

export const forecastStatuses = [
  { id: 'REG', name: '등록', val: 'REG' },
  { id: 'WON', name: '수주', val: 'WON' },
  { id: 'PROGRESS', name: '진행', val: 'PROGRESS' },
  { id: 'FAIL', name: '실패', val: 'FAIL' },
];
